module.exports = __webpack_public_path__ + "static/media/fare_03.ee28e4fc.png";